import React, { useState, useEffect, useContext } from 'react';
import { Paper, Box, Avatar, Grid, Chip, Typography, Button, CircularProgress, Pagination } from '@mui/material';
import { DataGrid } from "@mui/x-data-grid";
import ApiService from '../../functions/apiService';
import moment from 'moment';
import './position-assign.css'
import { toast } from 'react-toastify';
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import Modal from 'react-bootstrap/Modal';
import { Col, Row } from 'react-bootstrap';

const AssignmentRequests = ({ embedded = false }) => {
    const { user, v3Data } = useContext(AuthContext);
    const timeFormat = (timeStr) => timeStr?.slice(0, 5);
    const [loading, setLoading] = useState(false);
    const [assignmentList, setAssignmentList] = useState('');
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [reasonModal, setReasonModal] = useState(false);
    const [reason, setReason] = useState('');
    const [allowedVars, setAllowedVars] = useState({});
    const [absentReason, setAbsentReason] = useState('');

    let getAllowedVars = () => {
        ApiService.get('/v3Variables')
            .then((res) => {
                setAllowedVars(res?.data?.data)
            }).catch(({ error }) => {
                console.log('error', error)
            });
    }

    useEffect(() => {
        getAllowedVars()
    }, [])

    const checkButtonStyle = {
        color: "#555555",
        minWidth: "0",
        paddingRight: ".02rem",
        ":hover": { color: "green", background: "none" },
    };

    const clearButtonStyle = {
        color: "#555555",
        minWidth: "0",
        paddingRight: ".02rem",
        ":hover": { color: "red", background: "none" },
    };

    const columns = [
        {
            field: 'Assignment_date', headerName: 'Date', flex: 1, minWidth: 160,
            valueGetter: (params) => {
                return moment(params?.row?.Shift_Date).format('ddd Do MMM YYYY');
            }
        },

        {
            field: 'name', headerName: 'Name', flex: 1, minWidth: 200,
            valueGetter: (params) => {
                return (params?.row?.employee?.employee_assignment?.EA_Rank + " " + params?.row?.employee?.fullName)
            }
        },

        {
            field: 'Shift', headerName: 'Shift', flex: 1, minWidth: 200,
            renderCell: (params) => {
                return <Chip
                    sx={{
                        height: 'auto',
                        '& .MuiChip-label': {
                            display: 'block',
                            whiteSpace: 'normal',
                        },
                    }}
                    style={{
                        textAlign: 'center',
                        padding: '6px 0px',
                        width: '90%',
                        color: '#2E3238',
                        fontSize: '12px',
                        backgroundColor: params.row.ShiftCode === "2" || params.row.Shift_Code == 2 ? 'rgba(255, 165, 0, 0.26)' : 'rgba(52, 152, 219, 0.16)',
                        border: params.row.ShiftCode === "2" || params.row.Shift_Code == 2 ? '1px solid rgba(255, 165, 0, 0.28)' : '1px solid rgba(52, 152, 219, 0.2)'
                    }}
                    label={params?.row?.shift?.Shift + " (" + params?.row?.shift?.Start_Time + " - " + params?.row?.shift?.End_Time + ")"}
                />;
            },
        },

        {
            field: 'Position', headerName: 'Position', flex: 1, minWidth: 140,
            renderCell: (params) => (
                <Chip
                    sx={{
                        height: 'auto',
                        '& .MuiChip-label': {
                            display: 'block',
                            whiteSpace: 'normal',
                        },
                    }}
                    style={{
                        textAlign: 'center',
                        padding: '6px 0px',
                        width: '100%',
                        color: '#2E3238',
                        fontSize: '12px',
                    }}
                    label={params?.row?.position_assignment?.position_name?.SO_Desc}
                />
            ),
        },

        {
            field: 'Assignment', headerName: 'Requested At', flex: 1, minWidth: 140,
            renderCell: (params) => {
                const isoString = params?.row?.Requested_At;
                if (!isoString) return '';
                const date = moment(isoString);
                return varFormatTime(date.format('MM/DD/YYYY HH:mm'), user?.Time_Format);
            }
        },

        {
            field: 'action',
            headerName: 'Action',
            flex: 1,
            minWidth: 80,
            renderCell: (params) => {
                return params?.row?.Status === 'pending' ? (
                    <>
                        <Button
                            onClick={() => shiftAction(params?.row?.Id, 'accepted')}
                            sx={checkButtonStyle}
                            startIcon={<CheckIcon />}
                        ></Button>

                        <Button
                            onClick={() => shiftAction(params?.row?.Id, 'rejected')}
                            sx={clearButtonStyle}
                            startIcon={<ClearIcon />}
                        ></Button>
                    </>
                ) : params?.row?.Status === 'accepted' ? (
                    <Chip style={{ width: '80px' }}
                        color={'DarkGreen'}
                        label={"Accepted"} />
                ) : (
                    <Chip style={{ width: '80px' }}
                        color={'primary'}
                        label={"Rejected"} />
                );
            },
        }
    ]

    const getAssignmentList = () => {
        setLoading(true)
        ApiService.get(`/requestAssignmentShiftList?page=${currentPage}`)
            .then(({ data }) => {
                setAssignmentList(data?.data);
                setTotalPages(Math.ceil(data?.data?.total / data?.data?.per_page));
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            });
    }

    const handlePageChange = (_, value) => {
        setCurrentPage(value);
    }

    const shiftAction = (id, status) => {
        ApiService.post("/updateRequestAssignmentShiftStatus", {
            "Request_Assignment_Id": id,
            "Status": status
        })
            .then((data) => {
                toast.success(data?.message)
                getAssignmentList(false)
            })
            .catch((error) => {
                toast.error(error?.data?.message)
            });
    }

    useEffect(() => {
        getAssignmentList()
    }, [])

    useEffect(() => {
        getAssignmentList()
    }, [currentPage])

    return (
        <>
            {loading ? (
                <Box className="w-100 d-flex justify-content-center align-items-center font-fam" sx={{ minHeight: embedded ? 260 : 400 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Paper elevation={embedded ? 0 : 1} className={embedded ? "font-fam" : "p-4 font-fam"} style={embedded ? { fontFamily: 'Karla' } : { marginTop: "1rem" }}>
                    {!embedded && (
                        <Grid container spacing={2}>
                            <Grid item xs={10} md={9}>
                                <Typography variant="h5">Assignment Requests</Typography>
                            </Grid>
                        </Grid>
                    )}

                    {(!assignmentList || assignmentList.length == 0) ?
                        <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: embedded ? 280 : 565 }}>
                            <img src='/images/blur-logo.png' style={{ height: embedded ? 140 : 200, width: embedded ? 175 : 250 }} />
                            <span className='mt-4' style={{ color: '#555555' }}>
                                No Assignment Requests Found
                            </span>
                        </div>
                        :
                        <>
                            <div className={embedded ? '' : 'mt-4'}>
                                <DataGrid
                                    rows={assignmentList}
                                    columns={columns}
                                    checkboxSelection={false}
                                    hideFooter={true}
                                    autoHeight
                                    getRowId={assignmentList?.id}
                                    sx={{
                                        fontFamily: 'Karla',
                                        border: '1px solid #EAECF0',
                                        borderRadius: '10px',
                                        '& .MuiDataGrid-columnHeaders': {
                                            backgroundColor: '#F9FAFB',
                                            fontWeight: 600,
                                        },
                                        '& .MuiDataGrid-cell': {
                                            display: 'flex',
                                            alignItems: 'center',
                                        },
                                        '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                                            outline: 'none',
                                        },
                                        '& .MuiDataGrid-row:hover': {
                                            backgroundColor: 'rgba(191, 29, 45, 0.03)',
                                        },
                                    }}
                                />
                            </div>
                            <Pagination
                                count={totalPages}
                                page={currentPage}
                                onChange={handlePageChange}
                                color="primary"
                                className="mt-3 d-flex"
                                style={{ justifyContent: 'end' }}
                            />
                        </>
                    }
                </Paper >
            )}

            {/* Reason Modal */}
            <Modal show={reasonModal} size="md"
                onHide={() => { setReasonModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title>Reason for Cancellation</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Row className='w-100 m-auto' style={{ flexWrap: 'wrap' }}>
                        {reason &&
                            <div className="p-0" style={{ color: '#000', marginBottom: '12px' }}>
                                Reason : {reason ? reason : ''}
                            </div>
                        }
                        {absentReason &&
                            <div className="p-0" style={{ color: '#000', marginBottom: '12px' }}>
                                Absent Code : {absentReason ? absentReason : ''}
                            </div>
                        }
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AssignmentRequests